import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Cart} from "./dtos/cart";
import {NewDeliveryPoint} from "../../delivery-point/domain/dtos/new-delivery-point";

@Injectable({
    providedIn: 'root'
})
export abstract class CartRemote {
    public abstract validateOrder(cart: Cart): Observable<Cart>;
    public abstract finalizeOrder(cart: Cart, isDuplicated?:boolean): Observable<Cart>;
    public abstract finalizeOrderWithNewCustomer(cart: Cart, newCustomerData: NewDeliveryPoint, recaptchaToken: string, isDuplicated?:boolean): Observable<Cart>;
    public abstract getPaymentMethods(amountInMinorUnits: number): Observable<any>;
}
